import React, { FC } from 'react'

import { cx } from '@linaria/core'
import { styled } from '@linaria/react'
import { useIntl, defineMessages } from 'react-intl'

import { WithClassName } from 'common/types'
import flamingoSvg from 'components/designSystem/svg/flamingo.svg'
import { GQLGender } from 'generated-graphql/graphql'

export const ProfileNoImage: FC<
  WithClassName & {
    userId: number
    gender: GQLGender
  }
> = ({ userId, gender, className }) => {
  const intl = useIntl()

  return (
    <ProfileNoImageContainer
      data-name={`empty-photo-${gender}-${userId}`}
      className={cx(className)}
    >
      <ProfileNoImageImg
        src={flamingoSvg}
        width="100%"
        height="100%"
        alt={intl.formatMessage(messages.noImage)}
      />
    </ProfileNoImageContainer>
  )
}

const messages = defineMessages({
  noImage: {
    id: 'app.title.no_photo',
    defaultMessage: 'Нет фото',
  },
})

const ProfileNoImageContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  background-color: var(--background-surface-3);
`

const ProfileNoImageImg = styled.img`
  object-fit: cover;
`
